


























































































































































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { mdiMinus, mdiPlus } from '@mdi/js'
import {
  IProductAspectsItem,
  IProductAspectsVariant,
} from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
  },
})
export default class ComponentProductAspectsFull extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: [] }) readonly aspects: IProductAspectsItem[]
  @Prop({ type: String, default: 'шт' }) readonly unit!: string

  private async goUrl(url: string) {
    await this.$router.push(url)
  }

  private classAspectsItemVariantsItem(variant: IProductAspectsVariant) {
    return {
      [this.$style.aspectsItemVariantsItem]: true,
      [this.$style.inStock]: variant.inStock,
      [this.$style.active]: variant.active,
      [this.$style.outStock]: !variant.inStock,
      [this.$style.text]: !variant.image,
      [this.$style.image]: !!variant.image,
    }
  }

  private aspectItemsWithQuantity: IProductAspectsVariant[] = []
  private aspectItemsWithQuantityErrors: boolean[] = []

  private created() {
    const temp = this.aspects.find((item) => item.type === 'multi')
    if (temp) {
      this.aspectItemsWithQuantity = temp.variants.map((item) => {
        const temp = item
        if (
          temp.quantityCurrent === undefined ||
          temp.quantityCurrent === null
        ) {
          temp.quantityCurrent = temp.inStock ? 1 : 0
        }
        return temp
      })
      this.aspectItemsWithQuantityErrors.fill(
        false,
        0,
        this.aspectItemsWithQuantity.length - 1
      )
    }
    this.$emit('change-quantity', this.aspectItemsWithQuantity)
  }

  private updateAspectItemsWithQuantity(
    index: number,
    value: string | number,
    multiplicity: number = 1
  ) {
    let num = Number(value)
    if (this.aspectItemsWithQuantity[index] && !isNaN(num)) {
      num = Math.ceil(num / multiplicity) * multiplicity

      const temp = this.aspectItemsWithQuantity[index]
      temp.quantityCurrent = num > 0 ? num : 0
      this.$set(this.aspectItemsWithQuantity, index, temp)
      if (
        this.aspectItemsWithQuantity[index].quantityCurrent! >
        this.aspectItemsWithQuantity[index].quantityMax!
      ) {
        this.$set(this.aspectItemsWithQuantityErrors, index, true)
        const temp = this.aspectItemsWithQuantity[index]
        temp.quantityCurrent = this.aspectItemsWithQuantity[index].quantityMax
        this.$set(this.aspectItemsWithQuantity, index, temp)
      } else {
        this.$set(this.aspectItemsWithQuantityErrors, index, false)
      }
    } else {
      const temp = this.aspectItemsWithQuantity[index]
      temp.quantityCurrent = 0
      this.$set(this.aspectItemsWithQuantity, index, temp)
    }
    this.$emit('change-quantity', this.aspectItemsWithQuantity)
  }

  private icons = {
    mdiMinus,
    mdiPlus,
  }
}
